import React, { Component } from 'react';
import styled from 'styled-components';
import { getTheme } from '../../global/utils';
import Button from '../../components/buttons/Button';
import Heading from '../../components/text/Heading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import alarmsFiltersData from '../../data/alarmsFiltersData';

const AlarmsAppliedFiltersWrapper = styled.div`
  padding: ${getTheme('padding', 'verticalL')} 0 ${getTheme('padding', 'verticalXL')};
  border-top: 1px solid ${getTheme('black', '_800')};

  &.is-hidden {
    display: none;
  }

  .applied-filters {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    > * {
      margin-bottom: 0;
    }
    &__element {
      margin-right: ${getTheme('spacer', 'm')};
      button {
        text-transform: unset;
      }
      > * {
        margin-bottom: 0;
      }
    }
    &__label {
      font-size: ${getTheme('fontSize', 'caption')};
      color: ${getTheme('black', '_600')};
      margin-right: ${getTheme('spacer', 's')};
    }
    &__control {
      cursor: pointer;
      font-size: inherit;
      font-family: inherit;
      font-weight: inherit;
      margin: 0;
      padding: 0;
      background: transparent;
      border: 0;
      display: flex;
      align-items: center;
    }
    &__control-icon {
      color: inherit;
      margin-left: ${getTheme('spacer', 's')};
      font-size: 0.6em;
    }
  }
`;

class AlarmsAppliedFilters extends Component {
  constructor() {
    super();
    this.state = {
      appliedFiltersOpen: true,
    };
  }
  render() {
    let hiddenClass = 'is-hidden';
    let totalAppliedFilters = 0;
    if (
      this.props.activeFilters.ut > 0 ||
      this.props.activeFilters.groupid > 0 ||
      this.props.activeFilters.triggerid > 0
    ) {
      hiddenClass = '';
    }

    if (this.props.activeFilters.ut > 0) {
      totalAppliedFilters++;
    }
    if (this.props.activeFilters.groupid > 0) {
      totalAppliedFilters++;
    }
    if (this.props.activeFilters.triggerid > 0) {
      totalAppliedFilters++;
    }

    return (
      <AlarmsAppliedFiltersWrapper className={hiddenClass}>
        <Heading level="heading6">
          <h3>
            <button
              className="applied-filters__control"
              onClick={() => {
                this.setState({ appliedFiltersOpen: !this.state.appliedFiltersOpen });
              }}
            >
              Applied Filters ({totalAppliedFilters})
              {this.state.appliedFiltersOpen === true && (
                <FontAwesomeIcon className="applied-filters__control-icon" icon={faChevronUp} />
              )}
              {this.state.appliedFiltersOpen === false && (
                <FontAwesomeIcon className="applied-filters__control-icon" icon={faChevronDown} />
              )}
            </button>
          </h3>
        </Heading>
        {this.state.appliedFiltersOpen === true && (
          <div className="applied-filters">
            {this.props.activeFilters.ut > 0 && (
              <div className="applied-filters__element">
                <span className="applied-filters__label">UT:</span>
                <Button
                  pill
                  size="xsmall"
                  iconAfter={<FontAwesomeIcon icon={faTimes} />}
                  onClick={() => {
                    this.props.updateFilters({ ut: 0 });
                  }}
                >
                  {alarmsFiltersData.ut[this.props.activeFilters.ut].label}
                </Button>
              </div>
            )}

            {this.props.activeFilters.groupid > 0 && (
              <div className="applied-filters__element">
                <span className="applied-filters__label">Group:</span>
                <Button
                  pill
                  size="xsmall"
                  iconAfter={<FontAwesomeIcon icon={faTimes} />}
                  onClick={() => {
                    this.props.updateFilters({ groupid: 0 });
                  }}
                >
                  {alarmsFiltersData.groupid[this.props.activeFilters.groupid].label}
                </Button>
              </div>
            )}

            {this.props.activeFilters.triggerid > 0 && (
              <div className="applied-filters__element">
                <span className="applied-filters__label">Trigger:</span>
                <Button
                  pill
                  size="xsmall"
                  iconAfter={<FontAwesomeIcon icon={faTimes} />}
                  onClick={() => {
                    this.props.updateFilters({ triggerid: 0 });
                  }}
                >
                  {alarmsFiltersData.triggerid[this.props.activeFilters.triggerid].label}
                </Button>
              </div>
            )}

            <Button
              pill
              secondary
              size="xsmall"
              onClick={() => {
                this.props.updateFilters({
                  ut: 0,
                  groupid: 0,
                  triggerid: 0,
                });
              }}
            >
              Remove all
            </Button>
          </div>
        )}
      </AlarmsAppliedFiltersWrapper>
    );
  }
}

export default AlarmsAppliedFilters;



// WEBPACK FOOTER //
// ./src/pages/alarms/AlarmsAppliedFilters.js